import React, { Component } from 'react';
import '../assets/scss/sidebar-nav.scss';
import {
  FiChevronDown,
  FiChevronUp,
  FiFileText, GoDashboard
} from "react-icons/all";
import { Link, withRouter } from "react-router-dom";

class CentralNavBar extends Component {
  state = {
    navBar: [
      {
        id: 1,
        text: 'Dashboard',
        path: '/',
        icon: <GoDashboard />,
      },
      {
        id: 2,
        text: 'Distribution House List',
        path: '/dwh/list',
        icon: <FiFileText />,
      },
      {
        id: 3,
        text: 'Purchase Orders',
        path: '/purchaseOrder/list',
        icon: <FiFileText />,
      },
      {
        id: 4,
        text: 'Stock Transfer Orders',
        path: '/dhPurchaseOrder/list',
        icon: <FiFileText />,
      }, {
        id: 5,
        text: 'Inter Godown Transfer',
        path: '/dhReturnOrder/list',
        icon: <FiFileText />,
      },
      {
        id: 6,
        text: 'Customer Orders',
        path: '/customerOrder/list',
        icon: <FiFileText />,
      },
      {
        id: 7,
        text: 'Return Requests',
        path: '/returnOrder/list',
        icon: <FiFileText />,
      },
      {
        id: 8,
        text: 'Products',
        path: '/product/list',
        icon: <FiFileText />,
      },
      {
        id: 9,
        text: 'Bundle Products',
        path: '#',
        icon: <FiFileText />,
        hasSubMenu: true,
        isCollapsed: true,
        subMenu: [
          {
            id: 1,
            text: 'Pack Bundle',
            path: '/bundle/create-pack',
            icon: <FiFileText />,
          },
          {
            id: 2,
            text: 'Pack List',
            path: '/bundle/list',
            icon: <FiFileText />,
          },
        ]
      },
      {
        id: 10,
        text: 'Temporary Images',
        path: '#',
        icon: <FiFileText />,
        hasSubMenu: true,
        isCollapsed: true,
        subMenu: [
          {
            id: 1,
            text: 'Temporary Image',
            path: '/temporaryImages'
          },
        ]
      },
      {
        id: 11,
        text: 'Routes',
        path: '/route/list',
        icon: <FiFileText />,
      },
      {
        id: 12,
        text: 'Suppliers',
        path: '/supplier/list',
        icon: <FiFileText />,
      },
      {
        id: 13,
        text: 'Partners',
        path: '/partner/list',
        icon: <FiFileText />,
      },
      {
        id: 14,
        text: 'RA',
        path: '/ra/list',
        icon: <FiFileText />,
      },
      {
        id: 15,
        text: 'Riders',
        path: '/rider/list',
        icon: <FiFileText />,
      },
      {
        id: 16,
        text: 'Promotions',
        path: '#',
        icon: <FiFileText />,
        hasSubMenu: true,
        isCollapsed: true,
        subMenu: [
          {
            id: 1,
            text: 'Flash Sale',
            path: '/flashSale/list',
            icon: <FiFileText />,
          },
          {
            id: 2,
            text: 'Coupon Generation',
            path: '/coupon/list',
            icon: <FiFileText />,
          },
          {
            id: 3,
            text: 'Promotional Coupons',
            path: '/promo-coupon/list',
            icon: <FiFileText />,
          },
          {
            id: 4,
            text: 'Others',
            path: '/promotions/list',
            icon: <FiFileText />,
          },
        ]
      },
      {
        id: 17,
        text: 'Categories',
        path: '/category/list',
        icon: <FiFileText />,
      },
      {
        id: 18,
        text: 'Attribute',
        path: '/attribute/list',
        icon: <FiFileText />,
      },
      {
        id: 19,
        text: 'Sliders',
        path: '#',
        icon: <FiFileText />,
        hasSubMenu: true,
        isCollapsed: true,
        subMenu: [
          {
            id: 1,
            text: 'Common Sliders',
            path: '/common-slider/list',
            icon: <FiFileText />,
          },
          {
            id: 2,
            text: 'Promotional Sliders',
            path: '/promotional-slider/list',
            icon: <FiFileText />,
          },
        ]
      },
      {
        id: 20,
        text: 'Location',
        path: '/location/list',
        icon: <FiFileText />,
      },
      {
        id: 21,
        text: 'Inventory',
        path: '/inventory/list',
        icon: <FiFileText />,
      },
      {
        id: 22,
        text: 'Qc Failed Items',
        path: '/qcFailedItems/list',
        icon: <FiFileText />,
        hasSubMenu: true,
        isCollapsed: true,
        subMenu: [
          {
            id: 1,
            text: 'PO Failed Items',
            path: '/po-failed-items/list',
            icon: <FiFileText />,
          },
          {
            id: 2,
            text: 'IGT Failed Items',
            path: '/igt-failed-items/list',
            icon: <FiFileText />,
          },
        ]
      },
      {
        id: 23,
        text: 'Brands',
        path: '/brands/list',
        icon: <FiFileText />,
      },
      {
        id: 24,
        text: 'Blocked Items',
        path: '/blockItems/list',
        icon: <FiFileText />,
      },
      {
        id: 25,
        text: "Review List",
        path: "/reviews/list",
        icon: <FiFileText />,
      },
      {
        id: 26,
        text: "Requested Product List",
        path: "/product-request/list",
        icon: <FiFileText />,
      },
      {
        id: 27,
        text: 'Attribute Sets',
        path: '/attributeSet/list',
        icon: <FiFileText />,
      },

      {
        id: 28,
        text: "Contact Us List",
        path: "/contact-us/list",
        icon: <FiFileText />,
      },
      {
        id: 29,
        text: "Help Topic List",
        path: "/help-topic/list",
        icon: <FiFileText />,
      },
      {
        id: 30,
        text: "Article List",
        path: "/articles/list",
        icon: <FiFileText />,
      },
      {
        id: 31,
        text: "Feedbacks",
        path: "/feedbacks/list",
        icon: <FiFileText />
      },
      {
        id: 32,
        text: 'Page Meta Info',
        path: '/meta-info/list',
        icon: <FiFileText />,
      },
      {
        id: 33,
        text: "Deactivation/ Deletion Reasons",
        path: "/acc-delete-reason/list",
        icon: <FiFileText />,
      },
      {
        id: 34,
        text: "Audit Logs",
        path: "/audit-logs/list",
        icon: <FiFileText />,
      },
    ]
  };

  componentDidMount() {
    const parent_id = this.props.history?.location?.state?.parent_id;
    console.log(parent_id);
    if (parent_id) {
      const navBar = { ...this.state.navBar };
      const itemObj = this.state.navBar.filter(obj => {
        return obj.id === parent_id
      });
      const index = this.state.navBar.indexOf(itemObj[0]);
      navBar[index].isCollapsed = false;
      this.setState(navBar);
    }
  }

  toggleSubNavItems = async (id) => {
    const navBar = { ...this.state.navBar };
    const itemObj = await this.state.navBar.filter(obj => {
      return obj.id === id
    });
    const index = this.state.navBar.indexOf(itemObj[0]);
    navBar[index].isCollapsed = !navBar[index].isCollapsed;
    this.setState(navBar);
  };

  render() {
    return (
      <div className="sidebar-nav collapsed-sidebar">
        <ul className="navigation">
          {this.state.navBar.map((item, i) => {
            if (item.hasSubMenu) {
              return (
                <li key={i} className={item.isCollapsed ? 'has-sub-menu' : 'show-sub-menu has-sub-menu'}>
                  <span
                    onClick={() => {
                      this.toggleSubNavItems(item.id);
                    }}
                    className="toggleCollapse nav-link">
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-text">
                      <span className="text">{item.text}</span>
                      <span className="catet-icon">{item.isCollapsed ? <FiChevronDown /> : <FiChevronUp />}</span>
                    </span>
                  </span>

                  <ul className="sub-menu">
                    {item.subMenu.map((subItem, i) => {
                      return (<li key={i}><Link
                        className={`nav-link ${this.props?.history?.location?.pathname === subItem.path && "active-link"} `}
                        to={{ pathname: subItem.path, state: { parent_id: item.id } }}><span
                          className="nav-text">{subItem.text}</span></Link></li>)
                    })}
                  </ul>
                </li>
              )
            } else {
              return (
                <li key={i}>
                  <Link
                    className={`nav-link ${this.props?.history?.location?.pathname === item.path && !this.props?.history?.location?.state && "active-link"} `}
                    to={item.path}>
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-text">{item.text}</span>
                  </Link>
                </li>
              )
            }
          })}
        </ul>
      </div>
    );
  }
}




export default (withRouter(CentralNavBar));
